import {
  UserAuthStateContainer,
  AuthFormType,
  IUserLoginDetails,
  validateToken,
} from '@ihsm/ui-shared';
import { ENV_CONFIG } from 'constants/environment';
import React, { useCallback, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { ROOT } from 'routes';
import { useActions, useAppSelector } from 'state/store';
import AuthPage from './AuthPage';
import './SignInPage.scss';

export const SignInPage: React.FC = (): JSX.Element => {
  const { token, awsPoolData } = useAppSelector((state) => state.authState);
  const { setToken, setUserEmail } = useActions();
  const history = useHistory();

  const onSignin = useCallback(
    ({ authToken, userId }: IUserLoginDetails) => {
      if (authToken) {
        setToken(authToken);
        setUserEmail(userId);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [token]
  );

  useEffect(() => {
    if (token && validateToken()) {
      history.push(ROOT);
    }
  }, [token, history]);

  return (
    <AuthPage>
      <div className="sign-in-content">
        <UserAuthStateContainer
          loginFormTitle="Financial Risk Analytics"
          loginFormProductTitle="Buy Side Risk"
          onCompleted={onSignin}
          authFormType={AuthFormType.Login}
          cognitoUserPoolConfig={awsPoolData}
          userIdType={ENV_CONFIG().USER_ID_TYPE}
        />
      </div>
    </AuthPage>
  );
};
